import { Row, SvgImage } from '@components'
import { StyleCardTitle, StyleColumn } from '@components/styles'
import { FilterProps } from '.'
import { StyleSearchInput, StyleSearchInputWrapper } from './style'
interface IFilter {
  filter: FilterProps
  tableTitle?: string
}
const Filter = ({ filter, tableTitle }: IFilter) => {
  const { hasSearch, onSearch, rightComponent, filterComponent } = filter
  return (
    <>
      <StyleColumn
        customStyle={{
          paddingLeft: 20,
          paddingRight: 20,
          marginBottom: 20,
        }}
      >
        <Row
          justifyContent="space-between"
          alignItems="center"
          styleRow={{
            '@media (max-width: 768px)': {
              flexWrap: 'wrap',
              gap: 12,
            },
          }}
        >
          <Row styleRow={{ width: '80%', gap: 10 }} alignItems="center">
            {tableTitle && (
              <StyleCardTitle style={{ marginBottom: 0 }}>
                {tableTitle}
              </StyleCardTitle>
            )}

            {!!hasSearch && (
              <StyleSearchInputWrapper>
                <SvgImage src={'search'} />

                <StyleSearchInput
                  placeholder={
                    !!filter?.placeholder ? filter?.placeholder : 'Search...'
                  }
                  onChange={onSearch}
                />
              </StyleSearchInputWrapper>
            )}
            {!!filterComponent && filterComponent}
          </Row>

          {!!rightComponent && rightComponent}
        </Row>
      </StyleColumn>
    </>
  )
}

export default Filter
